<ng-select
  class="w-100"
  [items]="clients || []"
  bindValue="id"
  bindLabel="name"
  [multiple]="multiple"
  [disabled]="disabled"
  [clearable]="clearable"
  [searchFn]="clientSearchFn"
  [ngModel]="model"
  (ngModelChange)="onModelChange($event)"
  (blur)="onBlur()"
  [name]="name"
  [placeholder]="placeholder"
>
  <ng-template ng-option-tmp let-item="item">
    <div>
      <div>{{ item.humanizedName || item.name }}</div>
      <div class="ms-2"><em>{{ item.name }}</em></div>
    </div>
  </ng-template>
</ng-select>
